import { css } from 'lit';
export const baseStyles = css `
  /*
    Much specfificty
    Proceed with caution
  */
  :host * {
    font-family: 'VSCO Gothic', var(--grain-global-fontFamily-systemFont);
    /*
      @TODO:
      Included to maintain consistency with
      legacy VSCO web platforms. However,
      should ultimately be removed as nonstandrd.
    */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;
